import script from "./TabsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabsPage.vue?vue&type=script&lang=ts&setup=true"

import "./TabsPage.vue?vue&type=style&index=0&id=2925308e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2925308e"]])

export default __exports__